const daTranslation = {
    // Common
    language: "Dansk",
    months: {
        jan: "Januar",
        feb: "Februar",
        mar: "Marts",
        apr: "April",
        may: "Maj",
        jun: "Juni",
        jul: "Juli",
        aug: "August",
        sep: "September",
        oct: "Oktober",
        nov: "November",
        dec: "December"
    },
    weekDays: {
        mon: "Man",
        tue: "Tir",
        wed: "Ons",
        thu: "Tor",
        fri: "Fre",
        sat: "Lør",
        sun: "Søn"
    },

    // Navigation
    navigation: {
        features: "Funktioner",
        aboutUs: "Om os",
        pricing: "Priser",
        partners: "Partnere",
        contact: "Kontakt",
        testimonials: "Testimonial",

        login: "Log ind",
        dashboard: "Dashboard"
    },

    // Footer
    footer: {
        aboutDrivn: "Om Drivn",
        resources: "Ressourcer",
        legal: "Juridisk",
        linkedIn: "LinkedIn",
        faq: "FAQ",
        customerSupport: "Kontakt os",
        contactUs: "Kontakt salg",
        privacyPolicy: "Privatlivspolitik",
        termsConditions: "Vilkår & Betingelser",
        rights: "Alle rettigheder forbeholdes."
    },

    // Pricing page
    pricing: {
        title: "Priser",
        subtitle: "Gør CO₂ målbart uden papirarbejde",
        setupFee: "opsætningsgebyr",
        bookMeeting: "Book et møde",
        badge: "Priser",
        viewAllServices: "Se alle tjenester",
        custom: "Efter aftale",
        contactSales: "Kontakt salg",
        price: "Pris",
        perProject: "pr. projekt",
        perCompany: "pr. virksomhed",
        perYear: "/ år",
        groups: {
            coreServices: {
                title: "Medarbejder & Drift",
                description: "Strømlin medarbejderstyring, tidsregistrering og overholdelse med vores abonnementsbaserede tjenester."
            },
            customSolutions: {
                title: "Bæredygtighed & Compliance",
                description: "Skræddersyede løsninger til sporing af miljøpåvirkning og overholdelse af lovgivning for dine projekter."
            }
        },
        otherServices: {
            title: "Andre tjenester",
            description: "Udforsk alle vores tjenester og priser",
            features: {
                timeRegistration: {
                    title: "Tidsregistrering",
                    description: "Lovpligtig, automatiseret sporing og brugervenlig mobiloplevelse."
                },
                drivingAllowance: {
                    title: "Kørselsgodtgørelse",
                    description: "GPS-baseret kilometerregistrering med skattekompatibel rapportering."
                },
                co2: {
                    title: "CO₂-sporing",
                    description: "Automatiseret emissionsberegning og ESG-klare dashboards."
                }
            }
        },
        features: {
            fast: "Hurtig og pålidelig",
            fastDesc: "Vi har gjort det hurtigt og pålideligt."
        },
        plans: {
            lcaA4: {
                name: "LCA A4",
                description: "Automatiseret sporing af byggetransportemissioner for LCA A4-overholdelse.",
                features: {
                    transportModes: {
                        title: "Transportsporing",
                        description: "Automatisk data for al transport i projekter."
                    },
                    payloadUtil: {
                        title: "Last & effektivitet",
                        description: "Medregner lastfaktorer, tomkørsel og udnyttelse."
                    },
                    fuel: {
                        title: "Brændstoftyper",
                        description: "Præcise faktorer pr. brændstoftype."
                    }
                }
            },
            packaging: {
                name: "Producentansvar",
                description: "CO₂- og EPR-gebyr estimater for emballage med genanvendelighedstjek.",
                features: {
                    components: {
                        title: "Komponenter, materialer & vægte",
                        description: "Indtast materialer, formater og vægte pr. komponent."
                    },
                    co2Factors: {
                        title: "Automatiske CO₂-faktorer",
                        description: "Materiale- og markeds-specifikke emissionsfaktorer anvendes."
                    },
                    epr: {
                        title: "EPR-gebyr estimater (EU 2025)",
                        description: "Landespecifikke estimater i tråd med nye EU-krav."
                    },
                    reporting: {
                        title: "Genanvendelighed & rapportering",
                        description: "Designtjek, sammenligninger og eksportérbar PDF/CSV."
                    }
                }
            },
            scope12: {
                name: "Scope 1 & 2",
                description: "Registrer energiforbrug og beregn CO₂ på tværs af direkte og indirekte emissioner.",
                features: {
                    autoCalc: {
                        title: "Automatisk CO₂-beregning",
                        description: "Udledning beregnes ud fra energitype, site-lokation og relevante faktorer."
                    },
                    municipalFactors: {
                        title: "Kommunespecifikke faktorer",
                        description: "Energinet miljødeklarationer (125% metode) anvendes pr. site."
                    },
                    pdfUpload: {
                        title: "PDF-faktura upload",
                        description: "AI-drevet dataudtræk med manuel validering."
                    },
                    dashboard: {
                        title: "Dashboard & rapportering",
                        description: "Visuelle CO₂-trends, filtrering efter periode og eksportérbare PDF-rapporter."
                    }
                }
            },
            timeRegistration: {
                name: "Tidsregistrering",
                description: "Enkel og omkostnings- effektiv tidsregistreringsløsning",
                features: {
                    legalCompliance: {
                        title: "Juridisk overholdelse",
                        description: "EU & danske arbejdstidsregler"
                    },
                    automaticTracking: {
                        title: "Automatisk sporing",
                        description: "Præcis GPS-sporing, geofencing & mobil login"
                    },
                    userFriendly: {
                        title: "Brugervenlig grænseflade",
                        description: "Fungerer på alle enheder"
                    },
                    timePolicy: {
                        title: "Tidsregistreringspolitik",
                        description: "495 pr. kontrakt"
                    }
                }
            },
            drivingAllowance: {
                name: "Kørselsgodtgørelse",
                description: "Eliminer manuel registrering og sikr skattekompliant kørselsrefusion",
                features: {
                    gpsTracking: {
                        title: "GPS-baseret sporing",
                        description: "Automatisk præcis kilometerregistrering"
                    },
                    taxCompliance: {
                        title: "Skattemyndighedskompatibel",
                        description: "Beregninger i henhold til skatteregler"
                    },
                    accounting: {
                        title: "Regnskabsintegration",
                        description: "Eksporter data til økonomisystemer"
                    },
                    dashboard: {
                        title: "Administrationsdashboard",
                        description: "Overblik og godkendelsesprocesser"
                    }
                }
            },
            co2: {
                name: "Drivn CO₂",
                description: "Spor og reducer virksomhedens CO₂-aftryk",
                features: {
                    automatedCalc: {
                        title: "Automatiserede beregninger",
                        description: "Præcis CO₂-emissionssporing"
                    },
                    dashboard: {
                        title: "Realtidsdashboard",
                        description: "Visuelle analyser og overvågning"
                    },
                    esgCompliance: {
                        title: "ESG-overholdelse",
                        description: "Support til myndighedsrapportering"
                    },
                    integration: {
                        title: "Systemintegration",
                        description: "Fungerer med din eksisterende software"
                    }
                }
            },
            allInOne: {
                name: "Alt-i-én løsning for Medarbejder & Drift",
                description: "Integrér tidsregistrering, kørselsgodtgørelse og CO₂-overvågning i én samlet platform",
                features: {
                    complete: {
                        title: "Komplet løsning",
                        description: "Alle moduler i én integreret pakke"
                    },
                    reporting: {
                        title: "Konsolideret rapportering",
                        description: "Kombinerede analyser og dashboards"
                    },
                    integration: {
                        title: "Virksomhedsintegration",
                        description: "Problemfri forbindelse til dine systemer"
                    }
                },
                popular: "Populær"
            }
        },
        perMonth: "/ måned",
        perUserPerMonth: "/ bruger / måned",
        perContract: "pr. kontrakt"
    },

    // Plan names
    plans: {
        timeRegistration: "Tidsregistrering",
        drivingAllowance: "Kørselsgodtgørelse",


    },

    // Plan descriptions
    planDescriptions: {
        growth: "Vores mål er at strømline SMV-handel og gøre det nemmere og hurtigere end nogensinde for alle og overalt.",
        enterprise: "Vores mål er at strømline SMV-handel og gøre det nemmere og hurtigere end nogensinde for alle og overalt."
    },

    // Login page
    login: {
        title: "Log ind på din konto",
        email: "Din e-mail",
        emailPlaceholder: "navn@firma.com",
        password: "Adgangskode",
        passwordPlaceholder: "••••••••",
        rememberMe: "Husk mig",
        forgotPassword: "Glemt adgangskode?",
        loginButton: "Log ind"
    },

    // Contact Sales page
    contactSales: {
        title: "Kontakt salg"
    },

    // Features page
    features: {
        title: "Funktioner",
        subtitle: "Kraftfulde funktioner til din virksomhed",
        description: "Vi leverer værktøjer, der hjælper dig med at administrere din virksomhed effektivt."
    },

    // Overview page
    overview: {
        title: "Oversigt",
        subtitle: "Din virksomhed på et øjeblik",
        description: "Få et omfattende overblik over din virksomheds præstation."
    },

    // Home page
    home: {
        faq: {
            q1: "Hvilke produkter tilbyder Drivn?",
            a1: "Drivn tilbyder LCA A4 Transport til byggeemissioner, Producentansvar til EPR-rapportering, Automatisk kørselsgodtgørelse til korrekt kilometertal og Tidsregistrering til dokumentation af arbejdstid.",
            q2: "Hvordan hjælper LCA A4 Transport med compliance?",
            a2: "Løsningen automatiserer indsamling af transportemissioner til A4-kategorien og leverer dokumentation klar til LCA-krav og certificeringer.",
            q3: "Hvad dækker Producentansvar?",
            a3: "Den beregner emissioner efter materiale og format, estimerer EPR-gebyrer og giver vejledning om genanvendelighed og designforbedringer.",
            q4: "Hvordan fungerer Automatisk kørselsgodtgørelse?",
            a4: "GPS-baseret registrering opsamler erhvervskørsel automatisk, anvender korrekte skatteregler og eksporterer data til økonomi- eller lønsystemer.",
            q5: "Hvad kan Tidsregistrering hjælpe os med?",
            a5: "Gør ind- og udstempling enkel på mobil og desktop, understøtter fleksible skemaer og vagter samt leverer rapporter til compliance og løn.",
            title: "Ofte\nstillede\nspørgsmål",
            subtitle: "Har du spørgsmål? Kontakt os, og vores team vender tilbage til dig hurtigst muligt.",
            contact: "Kontakt os"
        },
        main: {
            title: "Gør CO₂-sporing målbar, håndterbar og compliant",
            subtitle: "Styrk din virksomhed med intuitive værktøjer til præcis CO₂-sporing, smidig håndtering og enkel compliance",
            getStartedButton: "Kom i gang",
            learnMoreButton: "Lær mere"
        },
        cta: {
            titleStart: "Klar til at komme",
            titleAccent: "i gang?",
            subtitle: "Tal med vores team om, hvordan Drivn kan hjælpe jeres virksomhed",
            emailButton: "Email vores team",
            bookMeeting: "Book et møde"
        },
        // Add Danish translations for the overview section
        overviewSection: {
            app: {
                title: "Drivn App: Styrk dine medarbejderes miljøbevidste pendling",
                description: "Løft dine medarbejderes daglige pendling med Drivn App'en. Designet med enkelhed og bæredygtighed for øje, muliggør vores app ubesværet registrering og administration af medarbejdernes rejser. Spor CO2-aftryk, deltag i grønne initiativer og støt miljømål automatisk.",
                features: {
                    registration: {
                        title: "Problemfri registrering:",
                        text: "Tilmeld dig med din organisationskode på få sekunder."
                    },
                    noEngage: {
                        title: "Ingen behov for at interagere med appen:",
                        text: "Logger automatisk i baggrunden uden behov for input."
                    },
                    realTime: {
                        title: "Realtidsdata:",
                        text: "Se dine arbejdsrelaterede transportemissioner i realtid."
                    },
                    greenGoals: {
                        title: "Grønne mål:",
                        text: "Deltag i virksomhedsudfordringer og bidrag til bæredygtighedsmål."
                    }
                }
            },
            dashboard: {
                title: "Drivn Dashboard: Indsigtsfuldt overblik for bæredygtighed",
                description: "Overgå til gennemsigtig og automatiseret CO2-regnskab med Drivns Dashboard. Ledere får et omfattende overblik over virksomhedens transportemissioner og tendenser. Udnyt dataens kraft til at træffe strategiske beslutninger, opfylde overholdelseskrav og gå forrest inden for virksomhedsansvar.",
                features: {
                    aggregated: {
                        title: "Aggregerede data:",
                        text: "Få et fugleperspektiv over virksomhedens pendlingsdata."
                    },
                    compliance: {
                        title: "Forenklet overholdelse:",
                        text: "Værktøjer skræddersyet til at opfylde CSRD- og ESG-rapportering."
                    },
                    insights: {
                        title: "Handlingsorienterede indsigter:",
                        text: "Analyser tendenser og mål effektiviteten af grønne politikker."
                    },
                    engage: {
                        title: "Engager og uddan:",
                        text: "Få adgang til ressourcer for at fremme en bæredygtighedskultur."
                    }
                }
            },
            charts: {
                emissions: {
                    title: "{{totalEmissions}} kg",
                    subtitle: "CO₂-Emissioner",
                    seriesName: "Emissioner",
                    yAxisLabel: "{{value}}kg"
                },
                commutes: {
                    subtitle: "Antal pendlerture",
                    seriesName: "Pendlerture"
                },
                distance: {
                    title: "Total Distance",
                    unit: "km",
                    seriesName: "Distance",
                    tooltipFormat: "{{value}} km"
                },
                transport: {
                    mostUtilizedValue: "Bil",
                    mostUtilized: "Mest anvendte transportmetode",
                    tooltipFormat: "{{value}} km",
                    methods: {
                        car: "Bil",
                        bus: "Bus",
                        train: "Tog",
                        bike: "Cykel",
                        walking: "Gang"
                    }
                },
                months: {
                    jan: "Jan",
                    feb: "Feb",
                    mar: "Mar",
                    apr: "Apr",
                    may: "Maj",
                    jun: "Jun"
                }
            }
        },
        // Features section
        featuresSection: {
            mainTitle: "Designet til bæredygtige virksomheder som din",
            mainDescription: "Hos Drivn fokuserer vi på at udnytte avancerede teknologier og kreativitet til at låse op for emissionsdata, der aldrig er set før",
            highQualityData: {
                title: "Højkvalitetsdata",
                description: "Eliminer menneskelige fejl og sikr højkvalitetsdata med vores fuldautomatisere sporing."
            },
            automated: {
                title: "100% automatiseret",
                description: "Vores mobilapp udnytter maskinlæring og adaptiv geofencing til automatisk at identificere og beregne emissioner fra arbejdsrelaterede pendlerture."
            },
            insights: {
                title: "Værdifulde indsigter",
                description: "Uddan dine medarbejdere i deres pendlervaner og relaterede emissioner."
            },
            compliance: {
                title: "Overholdelse",
                description: "Vores webbaserede adminpanel samler realtidsdata og hjælper dig med ubesværet at opfylde CSRD- og ESG-krav."
            }
        },
        // Products/Solutions section
        productsSolutions: {
            title: "Vores løsninger",
            subtitle: "Opdag hvordan Drivn automatiserer kilometersporing, sikrer overholdelse af regler og integreres problemfrit med din arbejdsgang.",
            badge: "Produkter",
            products: {
                tracking: {
                    id: "tracking",
                    title: "Drivn CO₂-sporing",
                    description: "Drivn CO₂ er et innovativt og brugervenligt system, der hjælper virksomheder med at registrere, overvåge og reducere deres CO₂-aftryk. Med automatiseret dataindsamling gør Drivn CO₂ det let at dokumentere miljøpåvirkning og opfylde ESG-krav samt lovgivningsmæssige rapporteringsstandarder.",
                    bulletPoints: [
                        { title: "Automatiseret CO₂-beregning:", text: "Indsamler og analyserer data fra virksomhedens aktiviteter for at give en præcis CO₂-rapportering." },
                        { title: "Live-overblik over emissioner:", text: " Intuitivt dashboard med realtidsdata og visuelle analyser." },
                        { title: "Compliance & ESG-rapportering:", text: "Understøtter dokumentation til myndigheder, investorer og certificeringsordninger." },
                        { title: "Optimering af bæredygtighedsstrategier:", text: "Identificerer CO₂-tunge processer og foreslår effektive reduktionstiltag." },
                        { title: "Integration med eksisterende systemer:", text: "Nem opsætning og kompatibilitet med økonomi-, transport- og produktionssoftware." }
                    ],
                    additionalInfo: "Drivn CO₂ er designet til virksomheder, der ønsker at tage ansvar for deres klimaaftryk og samtidig optimere deres forretningspraksis. Med vores løsning kan du træffe datadrevne beslutninger, reducere omkostninger og styrke din virksomheds grønne profil."
                },
                driving: {
                    id: "compliance",
                    title: "Drivn Automatiseret Kørselsgodtgørelse",
                    description: "Drivn tilbyder en automatiseret løsning til kørselsgodtgørelse, der eliminerer manuel registrering og sikrer præcise beregninger i overensstemmelse med Skattestyrelsens regler. Med GPS-sporing og automatisk logning af kørte kilometer reducerer systemet administrative byrder og minimerer risikoen for fejl.",
                    bulletPoints: [
                        { title: "Automatisk kørselsregistrering :", text: "GPS-baseret registrering sikrer præcis dokumentation af kørte kilometer." },
                        { title: "Overholder skattemæssige krav:", text: "Systemet beregner og dokumenterer kørselsgodtgørelse i henhold til gældende lovgivning." },
                        { title: "Integration med regnskabssystemer:", text: "Eksportér data direkte til virksomhedens økonomisystem for enkel bogføring." },
                        { title: "Tidsbesparende løsning:", text: "Eliminerer behovet for manuelle kørselsregnskaber og reducerer administrativt arbejde." },
                        { title: "Brugervenlig mobil- og webplatform:", text: "Medarbejdere kan nemt godkende og indsende kørselsdata med få klik." },
                        { title: "Øget gennemsigtighed og kontrol:", text: "Ledere får et klart overblik over medarbejdernes erhvervsmæssige kørsel." }
                    ],
                    additionalInfo: "Med Drivn Automatiseret Kørselsgodtgørelse får virksomheder en pålidelig og skalerbar løsning, der sikrer korrekt registrering, reducerer tidsforbrug og gør det lettere at overholde lovgivningskrav."
                },
                timeRegistration: {
                    id: "integration",
                    title: "Drivn Tidsregistrering",
                    description: "Drivn tilbyder markedets mest brugervenlige og prisvenlige tidsregistreringssystem, der sikrer, at din virksomhed overholder arbejdstidsloven og skaber overblik over medarbejdernes arbejdstimer. Med en fuldt digital og automatiseret løsning gør Drivn tidsregistrering let for både medarbejdere og ledere, samtidig med at det beskytter virksomheden juridisk.",
                    bulletPoints: [
                        { title: "Lovpligtig tidsregistrering:", text: "Overholder EU's arbejdstidsdirektiv og danske regler for arbejdstid." },
                        { title: "Automatisk registrering:", text: "Nøjagtig logning af arbejdstimer med GPS, geofencing og mobil-login." },
                        { title: "Enkel brugerflade:", text: "Medarbejdere kan nemt registrere mødetider via smartphone, tablet eller desktop." },
                        { title: "Fuld fleksibilitet:", text: "understøtter faste skemaer, skiftehold og fleksible arbejdstider." },
                        { title: "Rapporter og løn integration", text: "Genererer overskuelige rapporter og kan integreres med lønsystemer." },
                    ],
                    additionalInfo: "Med Drivn får du et tidsregistreringssystem, der sparer tid, sikrer compliance og reducerer administrative byrder. Løsningen er velegnet til virksomheder i alle størrelser, der ønsker en effektiv og problemfri registrering af arbejdstid."
                },
                lca: {
                    id: "lca",
                    title: "Drivn LCA A4 Transport",
                    description: "Drivn LCA A4 Transport automatiserer indsamling og dokumentation af transportemissioner (LCA A4) til og fra byggepladser, så din virksomhed kan opfylde livscyklusvurderingskrav uden regneark og manuel dataindsamling. Fra 1. juli 2025 skal CO₂-emissioner fra byggeri dokumenteres, og Drivn gør det nemt at være compliant fra dag ét.",
                    bulletPoints: [
                        { title: "A4-compliance klar:", text: "Indsamler og strukturerer automatisk de transportdata, der kræves til A4-kategorien i livscyklusvurderinger, så du altid har revisionsklare dokumenter." },
                        { title: "Realtids dataindsamling:", text: "Transportemissioner registreres løbende i takt med at leverancer og ture finder sted, så du har opdaterede projektdata uden at vente på manuelle rapporter." },
                        { title: "Grænseværdi-advarsler:", text: "Systemet overvåger dit projekts CO₂ i forhold til BR18-grænseværdien og sender advarsler, hvis du nærmer dig tærsklen, så du kan handle i tide." },
                        { title: "Leverandør- og underleverandørdata:", text: "Indsaml emissionsdata fra leverandører og underleverandører via den brancheomfattende leverandørdatabase og knyt det direkte til den relevante byggeplads." },
                        { title: "Certificeringssupport:", text: "Eksportér projektdata i formater, der er kompatible med DGNB, BREEAM og andre grønne bygningscertificeringer, til at understøtte dine bæredygtighedsmål." },
                        { title: "Projektbaserede dashboards:", text: "Få et klart visuelt overblik over transportemissioner pr. projekt, sammenlign byggepladser og følg fremskridt mod dine mål over tid." }
                    ],
                    additionalInfo: "Udviklet i samarbejde med CG Jensen giver Drivn LCA A4 Transport byggefirmaer og udviklere en pålidelig og skalerbar måde at dokumentere transportemissioner, reducere manuelt arbejde og holde sig foran lovkrav."
                },
                packaging: {
                    id: "packaging",
                    title: "Drivn Producentansvar",
                    description: "Drivn Producentansvar gør det nemt at håndtere dine emballagedata, beregne miljøpåvirkning og generere VANA-kompatible rapporter til udvidet producentansvar (EPR).",
                    bulletPoints: [
                        { title: "Produktregister:", text: "Vedligehold et komplet register over dine produkter med GTIN, emballagekomponenter og materialedetaljer." },
                        { title: "Nem dataimport:", text: "Upload produkt- og salgsdata via Excel/CSV eller tilføj produkter manuelt med vores guidede flow." },
                        { title: "Automatiseret VANA-rapportering:", text: "Generér kvartals-, måneds- eller brugerdefinerede rapporter, der opfylder VANA-kravene, på få trin." },
                        { title: "Vægt- og genanvendelsessporing:", text: "Følg den samlede emballagevægt og genanvendelsesgrader på tværs af dit produktsortiment." },
                        { title: "Dashboard-overblik:", text: "Få et klart overblik over produkter, solgte enheder, rapporter og compliancestatus fra ét samlet dashboard." }
                    ],
                    additionalInfo: "Uanset om du har en håndfuld produkter eller tusindvis, strømliner Drivn Producentansvar dit EPR-workflow, så du kan overholde reglerne med minimal indsats."
                },
                scope12: {
                    id: "scope12",
                    title: "Drivn Scope 1 & 2",
                    description: "Registrer din virksomheds energiforbrug og beregn CO₂-udledninger på tværs af både direkte og indirekte kilder, samlet i én platform.",
                    bulletPoints: [
                        { title: "Fuldt emissionsoverblik:", text: "Følg Scope 1 (brændstof, gas) og Scope 2 (indkøbt elektricitet) fra ét samlet dashboard." },
                        { title: "Automatisk CO₂-beregning:", text: "Upload fakturaer eller indtast forbrugsdata, og lad platformen beregne udledninger automatisk." },
                        { title: "Lokationsbaseret præcision:", text: "Scope 2-faktorer tilpasses automatisk til dit sites kommune via officielle Energinet-miljødeklarationer." },
                        { title: "AI-drevet dataindtastning:", text: "Intelligent PDF-ekstraktion aflæser dine fakturaer og registrerer energidata, så du sparer tid og undgår fejl." },
                        { title: "Rapportering & indsigt:", text: "Følg din præstation over tid med dashboards, filtrering og eksportklare rapporter." }
                    ],
                    additionalInfo: "Bygget til virksomheder på alle stadier af deres bæredygtighedsrejse, fra første måling til skaleret rapportering."
                }
            },
        },
        newProducts: {
            tag: "Nye Producter",
            title: "Sporing af byggetransportemissioner og producentansvar",
            lca: {
                title: "Drivn LCA A4 Transport",
                date: "Fra 1. juli 2025",
                dateText: ", skal CO₂-emissioner fra byggeri dokumenteres – ikke kun estimeres.",
                description: "Udviklet sammen med CG Jensen automatiserer Drivn LCA A4 Transport indsamling og dokumentation af transportemissioner (LCA A4) til og fra byggepladser, hvilket gør overholdelse ligetil.",
                keyFeatures: "Nøglefunktioner:",
                feature1: "Indsamler automatisk transportdata (A4) i realtid",
                feature2: "Beregner CO₂-emissioner direkte i forhold til grænseværdien i BR18",
                feature3: "Giver live-advarsler, hvis projektet nærmer sig overskridelse",
                feature4: "Indsamler data fra leverandører og underleverandører",
                databaseTitle: "Brancheomfattende Leverandørdatabase",
                databaseDesc: "Vores leverandørdatabase hjælper leverandører uden digitale løsninger med at linke deres emissionsdata direkte til byggepladser – tilgængelig for hele branchen."
            },
            packaging: {
                title: "Drivn Producentansvar",
                date: "Fra 1. oktober 2025",
                dateText: ", træder gebyrer for udvidet producentansvar (EPR) i kraft i hele EU – hvilket kræver nøjagtig rapportering af emballagepåvirkning.",
                description: "Drivn Producentansvar hjælper brands med at måle emballageemissioner, estimere EPR-gebyrer og verificere genanvendelighed, hvilket gør overholdelse og bæredygtighedsmål opnåelige.",
                keyFeatures: "Nøglefunktioner:",
                feature1: "Beregner automatisk CO₂ efter materiale, vægt og format",
                feature2: "Estimerer EPR-gebyrer baseret på landespecifikke regler",
                feature3: "Giver vejledning om genanvendelighed og anbefalinger til designforbedringer",
                feature4: "Muliggør scenariesammenligninger for designoptimering"
            }
        }
    },

    // Contact page
    contact: {
        title: "Har du et spørgsmål?",
        description: "Send det hertil, så vender vores team tilbage til dig hurtigst muligt",
        directEmailPrefix: "Du kan også kontakte os direkte på",
        email: "Din e-mail",
        emailPlaceholder: "f.eks. you@company.com",
        subject: "Emne for spørgsmål",
        subjectPlaceholder: "Beskriv kort emnet for dit spørgsmål",
        message: "Dit spørgsmål",
        messagePlaceholder: "Beskriv dit spørgsmål",
        submit: "Send dit spørgsmål",
        successTitle: "Besked sendt",
        successBody: "Tak for dit spørgsmål — vi vender tilbage til dig snarest.",
        successCta: "Forstået"
    },

    // FAQ page
    faq: {
        pageTitle: "FAQ",
        title: "Ofte stillede spørgsmål",
        questions: {
            howItWorks: {
                question: "Hvordan virker Drivn?",
                answer: "Drivn anvender en mobil applikation, som medarbejdere kan downloade til deres smartphones. Appen bruger geofencing og maskinlæring til at skelne mellem personlig og arbejdsrelateret transport. Dette giver os mulighed for automatisk at levere præcise data om CO2-udledninger genereret under medarbejdernes pendling. Individuelle data vil være tilgængelige for medarbejderen direkte i applikationen, mens de samlede data vil blive vist via et dashboard i Drivns administrationspanel."
            },
            benefits: {
                question: "Hvad er fordelene ved at bruge Drivn?",
                bulletPoints: [
                    "Overholdelse: Drivn hjælper virksomheder med at overholde miljøregler ved at levere realtidsdata om CO2-udledninger.",
                    "Medarbejderengagement: Vores platform gør bæredygtig pendling til en venlig konkurrence blandt medarbejdere, hvilket fremmer en kultur med miljøvenlige praksisser.",
                    "Datadrevne indsigter: Drivn tilbyder værdifulde indsigter i pendlingsmønstre, så virksomheder kan træffe informerede beslutninger for en grønnere fremtid."
                ]
            },
            privacy: {
                question: "Hvordan beskyttes brugerens privatliv?",
                answer: "Vi tager brugernes privatliv alvorligt. Drivn overholder alle relevante databeskyttelseslove inden for EU, og brugerne har kontrol over deres data. Vi giver tydelige oplysninger om de data, vi indsamler, og hvordan de anvendes, og brugerne kan til enhver tid fravælge eller deaktivere positionssporing. Der indgås en databehandleraftale i overensstemmelse med EU-standarder og Datatilsynet mellem klienten og Drivn ved virksomhedens onboarding. Yderligere information kan findes i vores Privatlivspolitik og Brugersamtykke."
            },
            getStarted: {
                question: "Hvordan kan min virksomhed komme i gang med Drivn?",
                answer: "Det er nemt at komme i gang! Tag blot kontakt til vores team, og vi guider dig gennem opsætningsprocessen. Vi hjælper dig med at tilpasse appen til din organisation, yder træning til dine medarbejdere og sikrer en problemfri integration i dine bæredygtighedsinitiativer."
            },
            compliance: {
                question: "Kan Drivn hjælpe med overholdelse af regler?",
                answer: "Absolut. Drivn er designet til at hjælpe virksomheder med at opfylde lovmæssige krav, især i forbindelse med GHG Protocol: scope 3 kategori 7 emissioner (Medarbejderpendling)."
            },
            dataInsights: {
                question: "Hvor ofte leverer Drivn dataindsigt?",
                answer: "Drivn giver realtidsindsigt, hvilket giver virksomheder mulighed for at få adgang til realtidsdata og information om pendlingsmønstre og CO2-udledninger. Dette sikrer, at organisationer kan træffe rettidige beslutninger for at reducere deres miljøpåvirkning."
            },
            userExpectations: {
                question: "Hvad forventes fra brugeren for at udnytte Drivn-appen?",
                answer: "For at sikre en problemfri oplevelse og nøjagtig dataindsamling opfordres brugere (medarbejdere) til at følge disse retningslinjer:",
                steps: [
                    "Download og registrering: Brugere skal downloade Drivn-appen fra det angivne link og registrere sig ved hjælp af deres organisations unikke kode.",
                    "Aktivér positionstjenester: For at muliggøre præcis sporing skal brugere aktivere \"tillad altid\"-indstillingen for positionstjenester til Drivn-appen. Drivn bruger positionsdata ansvarligt og respekterer brugerens privatliv.",
                    "Herefter kræves der ingen yderligere interaktion fra brugerens side, dog er analyser og statistik tilgængelige for brugeren at se, hvis ønsket."
                ]
            },
            transportModes: {
                question: "Hvilke typer transportmetoder dækker Drivn?",
                answer: "Drivn dækker omfattende forskellige transportmetoder og sikrer en komplet analyse af din organisations CO2-fodaftryk. De understøttede metoder omfatter:",
                modes: [
                    "Bil: Uanset om det er en firmabil eller personlig bil, sporer Drivn CO2-udledninger forbundet med bilpendling.",
                    "Tog og metro: For medarbejdere, der bruger offentlig transport, registrerer Drivn nøjagtigt udledninger relateret til togtransport.",
                    "Gang og cykling: Drivn genkender bæredygtige transportformer, såsom gang og cykling, hvilket bidrager til et holistisk syn på din miljøpåvirkning.",
                    "Bus: Drivn inkluderer også bustransport i sine sporingsmuligheder.",
                    "Andre transportmetoder dækket: Færge, Sporvogn, Metro."
                ]
            }
        },
        userConsent: "Brugersamtykke"
    },

    // Forgot Password page
    forgotPassword: {
        pageTitle: "Glemt adgangskode",
        title: "Nulstil din adgangskode",
        subtitle: "Indtast din e-mail her, og vi sender dig en e-mail, hvor du kan nulstille din adgangskode.",
        email: "Din e-mail",
        emailPlaceholder: "navn@firma.com",
        resetButton: "Nulstil adgangskode",
        sending: "Sender nulstilling af adgangskode...",
        error: "Der opstod en fejl",
        tryAgain: "Prøv igen",
        checkEmail: "Tjek din e-mail! (Og spam)",
        goToLogin: "Gå til log ind"
    },

    // Not Found page
    notFound: {
        pageTitle: "404",
        title: "Side ikke fundet",
        subtitle: "Beklager, vi kunne ikke finde den side, du leder efter.",
        goHome: "Gå tilbage til forsiden",
        contactSupport: "Kontakt support"
    },

    termsAndConditions: {
        pageTitle: "Vilkår og betingelser"
    },

    privacyPolicy: {
        pageTitle: "Privatlivspolitik"
    },

    knowledgeBank: {
        pageTitle: "Vidensbank",
        title: "Vidensbank",
        badge: "Ressourcer",
        search: "Søg i artikler...",
        backToSite: "Tilbage til siden",
        articles: "artikler",
        allCategories: "Alle Kategorier",
        hero: {
            title: "Hvordan kan vi hjælpe?",
            subtitle: "Find guides, vejledninger og svar for at få mest muligt ud af Drivn"
        },
        featured: {
            title: "Fremhævede Artikler"
        },
        help: {
            title: "Kan du ikke finde det, du leder efter?",
            description: "Vores supportteam er klar til at hjælpe dig med alle spørgsmål.",
            cta: "Kontakt Support"
        },
        navigation: {
            previous: "Forrige",
            next: "Næste"
        },
        article: {
            placeholder: "Denne artikel er under udarbejdelse. Kom tilbage snart for det fulde indhold.",
            overviewTitle: "Oversigt",
            keyPointsTitle: "Hovedpunkter",
            comingSoon: "Indhold kommer snart..."
        },
        categories: {
            gettingStarted: {
                title: "Kom i Gang",
                description: "Lær det grundlæggende om Drivn og kom hurtigt i gang",
                articles: {
                    introduction: "Introduktion til Drivn",
                    quickStart: "Hurtig Startguide",
                    accountSetup: "Kontoopsætning"
                },
                descriptions: {
                    introduction: "Lær hvad Drivn er, og hvordan det kan hjælpe din virksomhed",
                    quickStart: "Kom i gang med Drivn på få minutter",
                    accountSetup: "Opsæt din konto og konfigurer din organisation"
                }
            },
            sustainability: {
                title: "Bæredygtighed",
                description: "Forstå CO₂-sporing og miljøpåvirkning",
                articles: {
                    co2Tracking: "CO₂-sporing",
                    esgReporting: "ESG-rapportering",
                    emissionFactors: "Emissionsfaktorer"
                },
                descriptions: {
                    co2Tracking: "Hvordan Drivn automatisk sporer og beregner emissioner",
                    esgReporting: "Generer ESG-kompatible rapporter til interessenter",
                    emissionFactors: "Forstå de emissionsfaktorer, vi bruger"
                }
            },
            compliance: {
                title: "Compliance",
                description: "Opfyld lovgivningsmæssige krav med sikkerhed",
                articles: {
                    csrd: "CSRD-compliance",
                    euTaxonomy: "EU-taksonomi",
                    ghgProtocol: "GHG-protokol"
                },
                descriptions: {
                    csrd: "Hvordan Drivn hjælper dig med at overholde CSRD-krav",
                    euTaxonomy: "Forstå EU-taksonomien og hvordan den gælder",
                    ghgProtocol: "Scope 3-emissioner og GHG-protokollen"
                }
            },
            timeRegistration: {
                title: "Tidsregistrering",
                description: "Medarbejdertidsregistrering og compliance",
                articles: {
                    setup: "Opsætning af Tidsregistrering",
                    mobileApp: "Brug af Mobilappen",
                    reports: "Tidsrapporter"
                },
                descriptions: {
                    setup: "Konfigurer tidsregistrering for din organisation",
                    mobileApp: "Hvordan medarbejdere bruger mobilappen til tidsregistrering",
                    reports: "Generer og eksporter tidsregistreringsrapporter"
                }
            },
            drivingAllowance: {
                title: "Kørselsgodtgørelse",
                description: "Automatiseret kilometerregistrering og refusion",
                articles: {
                    gpsTracking: "GPS-sporing",
                    taxRules: "Skatteregler",
                    approval: "Godkendelsesflow"
                },
                descriptions: {
                    gpsTracking: "Hvordan GPS-baseret kilometerregistrering fungerer",
                    taxRules: "Forstå danske skatteregler for kørselsgodtgørelse",
                    approval: "Administrer godkendelsesflows for kørselsgodtgørelse"
                }
            },
            producerResponsibility: {
                title: "Producentansvar",
                description: "EPR-compliance og emballagesporing",
                articles: {
                    eprOverview: "EPR-oversigt",
                    packagingData: "Emballagedata",
                    feeCalculation: "Gebyrberegning"
                },
                descriptions: {
                    eprOverview: "Forstå udvidet producentansvar",
                    packagingData: "Hvordan du indtaster og administrerer emballagedata",
                    feeCalculation: "Hvordan EPR-gebyrer beregnes"
                }
            },
            faq: {
                title: "FAQ",
                description: "Ofte stillede spørgsmål og svar",
                articles: {
                    general: "Generelle Spørgsmål",
                    technical: "Tekniske Spørgsmål",
                    billing: "Faktureringsspørgsmål"
                },
                descriptions: {
                    general: "Almindelige spørgsmål om Drivn og vores tjenester",
                    technical: "Tekniske spørgsmål om integrationer og data",
                    billing: "Spørgsmål om priser, fakturaer og betalinger"
                }
            }
        }
    },

    partners: {
        pageTitle: "Partnere",
        badge: "Strategiske Partnere",
        title: "Vores Partnere",
        subtitle: "Vi samarbejder med brancheledere for at levere omfattende bæredygtighedsløsninger",
        visitWebsite: "Besøg hjemmeside",
        servicesTitle: "Hvad de tilbyder",
        specialties: {
            esg: "ESG-rådgivning"
        },
        services: {
            esgStrategy: {
                title: "ESG-strategiudvikling",
                description: "Omfattende bæredygtighedsplaner skræddersyet til dine forretningsmål"
            },
            compliance: {
                title: "Lovgivningsmæssig compliance",
                description: "Navigér CSRD, EU-taksonomi og andre ESG-rapporteringskrav"
            },
            reporting: {
                title: "Bæredygtighedsrapportering",
                description: "Professionelle ESG-rapporter der opfylder interessenternes forventninger"
            }
        },
        partnerList: {
            kbConsulting: {
                description: "K & B Consulting er et førende ESG-konsulentfirma, der specialiserer sig i at hjælpe virksomheder med at navigere i kompleksiteten omkring miljømæssige, sociale og ledelsesmæssige krav. Med dyb ekspertise inden for bæredygtighedsstrategi, ESG-rapportering og lovgivningsmæssig compliance arbejder de sammen med Drivn for at give kunderne både den nødvendige datainfrastruktur og strategiske vejledning til at opnå meningsfulde bæredygtighedsresultater."
            }
        },
        howWeWork: {
            title: "Sådan arbejder vi sammen",
            subtitle: "Vi kombinerer Drivns teknologi med ekspertrådgivning for komplette bæredygtighedsløsninger",
            steps: {
                data: {
                    title: "Dataindsamling",
                    description: "Drivn sporer og måler automatisk din virksomheds miljødata med præcision"
                },
                strategy: {
                    title: "Ekspertanalyse",
                    description: "K & B Consulting analyserer dataene og udvikler handlingsorienterede bæredygtighedsstrategier"
                },
                results: {
                    title: "Reelle resultater",
                    description: "Sammen hjælper vi dig med at opnå compliance, reducere udledninger og nå ESG-mål"
                }
            }
        },
        becomePartner: {
            title: "Interesseret i at samarbejde med Drivn?",
            description: "Vi søger altid efter bæredygtighedseksperter og konsulenter, der deler vores vision.",
            cta: "Kontakt os"
        }
    },

    aboutUs: {
        pageTitle: "Om os",
        title: "Om Drivn",
        subtitle: "Driver bæredygtige transportløsninger for moderne virksomheder",
        mission: {
            title: "Vores mission",
            description: "Hos Drivn giver vi virksomheder mulighed for at træffe datadrevne beslutninger om medarbejdertransport, mens de reducerer deres miljøpåvirkning. Vi tror på, at gennemsigtighed og automatisering er nøglen til at skabe en mere bæredygtig fremtid."
        },
        story: {
            title: "Vores historie",
            description: "Grundlagt i Danmark opstod Drivn fra behovet for præcise, automatiserede transportdata i erhvervslivet. Traditionelle metoder til at spore medarbejderpendling og forretningsrejser var ineffektive, tilbøjelige til fejl og manglede de granulære indsigter, der var nødvendige for meningsfuld miljøpåvirkningsvurdering."
        },
        values: {
            title: "Vores værdier",
            subtitle: "Principperne der guider alt hvad vi gør",
            sustainability: {
                title: "Bæredygtighed",
                description: "Vi er forpligtet til at hjælpe virksomheder med at reducere deres CO₂-aftryk gennem bedre data og indsigter."
            },
            transparency: {
                title: "Gennemsigtighed",
                description: "Vi leverer klare, ærlige data, der hjælper organisationer med at træffe informerede beslutninger."
            },
            innovation: {
                title: "Innovation",
                description: "Vi udnytter banebrydende teknologi til at løse komplekse transportudfordringer."
            },
            privacy: {
                title: "Privatliv",
                description: "Vi prioriterer brugernes privatliv og databeskyttelse i alt, hvad vi gør."
            }
        },
        team: {
            title: "Vores team",
            roles: {
                ceo: "Administrerende Direktør",
                founder: "Grundlægger",
                cto: "Chief Technology Officer",
                fullStackEngineer: "Full Stack Udvikler",
                softwareEngineer: "Software Udvikler",
                accountManager: "Account Manager"
            }
        },
        contact: {
            title: "Kom i kontakt",
            description: "Klar til at transformere din organisations transportdata? Kontakt os for at lære mere om, hvordan Drivn kan hjælpe din virksomhed."
        }
    },

    // Legend
    legend: {
        title: "Transport",
        methods: {
            car: "Bil",
            bike: "Cykel",
            walking: "Gang",
            bus: "Bus",
            train: "Tog",
            metro: "Metro"
        }
    },

    // Dashboard
    dashboard: {
        tabs: {
            allowance: "Kørselsgodtgørelse",
            timeReg: "Timeregistrering",
            emissions: "CO₂",
            employees: "Medarbejdere",
            departments: "Afdelinger",
            offices: "Kontorer",
            settings: "Indstillinger"
        },
        logout: "Log ud",
        organizationCode: "Organisationskode:",
        copied: "Kopieret til udklipsholder",
        loading: "Indlæser bruger...",
        notAdmin: {
            title: "Denne side er kun tilgængelig for administratorer",
            greeting: "Hej",
            message: "i øjeblikket er denne side kun tilgængelig for administratorbrugere. Hvis du burde have adgang til din organisations analyser,",
            contact: "kontakt din organisationsadministrator på",
            persist: "Hvis problemet fortsætter,",
            support: "kontakt support"
        },
        allowance: {
            title: "Kørselsgodtgørelse",
            status: {
                approved: "Godkendt",
                pending: "Afventer",
                rejected: "Afvist"
            },
            monthlyReport: {
                name: "Navn",
                distance: "Distance",
                reimbursement: "Udbetaling",
                emissions: "Udledning",
                status: "Status",
                approve: "Godkend",
                reject: "Afvis",
            },
            noData: "Ingen medarbejder har indsendt en kørselsgodtgørelse for den valgte måned",
        },
        timeRegistration: {
            title: "Timeregistrering",
            noEmployeeSelected: "Ingen medarbejder valgt",
            search: "Søg...",
            totalHours: "Afholdte timer",
            oughtToHours: "Forventede timer",
            departments: "Afdelinger",
            selectEmployee: "Vælg en medarbejder fra listen",
            month: "Måned",
            overviewTitle: "Overview of Hours Worked This Year",
            totalWorkedHours: "Totale afholdte timer",
            totalOughtToHours: "Totale forventede timer",
        },
        analytics: {
            loading: "Indlæser Analyser...",
            dateRangeControls: {
                last7days: "Sidste 7 Dage",
                week: "Uge",
                month: "Måned",
                year: "År",
                customRange: "Brugerdefineret Periode",
                dateRangeLabel: "Datointerval"
            },
            modal: {
                errorTitle: "Noget gik galt...",
                successTitle: "Download Vellykket!",
                loadingLabel: "Henter Datafil...",
                downloadReportFor: "Download Rapport for:",
                to: "til",
                cancel: "Annuller",
                download: "Download",
                downloadReport: "Download Rapport"
            },
            distance: {
                title: "Total Afstand",
                unit: "km",
                tooltipFormat: "{{value}} km"
            }
        },
        emissions: {
            emissions: {
                title: "CO₂-Emissioner",
                unit: "kg",
                increased: "Du brugte {{value}} kg sammenlignet med sidste periode",
                decreased: "Du sparede {{value}} kg i denne periode",
                chart: {
                    downloadButton: "Download brugerdefineret CSV",
                    day: "Dag",
                    date: "Dato",
                    emission: "Emissioner",
                    total: "Total",
                    months: [
                        "Januar", "Februar", "Marts", "April", "Maj", "Juni",
                        "Juli", "August", "September", "Oktober", "November", "December"
                    ]
                }
            },
            commutes: {
                title: "Antal Pendlerture",
                seriesName: "Pendlerture"
            },
            distance: {
                title: "Total Afstand Rejst",
                unit: "km",
                seriesName: "Afstand",
                tooltipFormat: "{{value}} km"
            },
            // ADDED: Transport section for pie chart
            transport: {
                mostUtilizedTitle: "Mest Anvendte Transportmetode",
                tooltipFormat: "{{value}} km",
                legendFormat: "{{seriesName}}: {{distance}} km",
                activityTypes: {
                    car: "Bil",
                    bus: "Bus",
                    train: "Tog",
                    walking: "Gang",
                    cycling: "Cykel",
                    metro: "Metro",
                }
            }
        },
        employees: {
            title: "Alle Brugere",
            breadcrumb: {
                dashboard: "Dashboard",
                allEmployees: "Alle Medarbejdere"
            },
            tableHeaders: {
                user: "Bruger",
                userRole: "Brugerrolle",
                department: "Afdeling",
                status: "Status"
            },
            pagination: {
                showing: "Viser",
                of: "af",
                previous: "Forrige",
                next: "Næste"
            },
            loading: "Indlæser Medarbejdere...",
            employeeCell: {
                roles: {
                    owner: "Ejer",
                    administrator: "Administrator",
                    employee: "Medarbejder"
                },
                status: {
                    active: "Aktiv",
                    removed: "Fjernet"
                },
                noSelection: "Ikke Valgt",
                delete: "Slet"
            },
            actions: {
                deleteSelected: "Slet Valgte",
            },
            confirmDelete: {
                title: "Bekræft Sletning",
                message: "Er du sikker på, at du vil slette de valgte {{count}} medarbejdere? Handlingen kan ikke fortrydes.",
                cancel: "Annuller",
                confirm: "Ja, Slet",
            }
        },
        departments: {
            title: "Alle Afdelinger",
            breadcrumb: {
                dashboard: "Dashboard",
                allDepartments: "Alle Afdelinger"
            },
            tableHeaders: {
                departmentName: "Afdelingsnavn",
                employeeCount: "Antal Medarbejdere",
                activeEmployees: "Aktive Medarbejdere",
                totalEmissions: "Samlede Emissioner",
                avgEmissions: "Gns. Medarbejderemissioner"
            },
            actions: {
                addDepartment: "Tilføj Afdeling",
                updateDepartment: "Opdater Afdeling",
                search: "Søg"
            },
            modal: {
                add: "Tilføj Afdeling",
                update: "Opdater Afdeling",
                departmentName: "Afdelingsnavn",
                departmentNamePlaceholder: "Afdelingsnavn",
                employeeCount: "Antal Medarbejdere",
                employeeCountPlaceholder: "Antal Medarbejdere",
                departmentColor: "Afdelingsfarve (Til Analyse)",
                travelsForBusiness: "Rejser i erhvervsøjemed"
            },
            pagination: {
                showing: "Viser",
                of: "af",
                previous: "Forrige",
                next: "Næste"
            },
            loading: "Indlæser Afdelinger...",
            toasts: {
                updating: "Opdaterer Afdeling...",
                updated: "Afdeling blev opdateret",
                creating: "Opretter Afdeling...",
                created: "Afdeling blev oprettet",
                removing: "Fjerner Afdeling...",
                removed: "Afdeling blev fjernet"
            },
            delete: "Slet",
            confirm: {
                title: "Slet Afdeling",
                message: "Er du sikker på, at du vil slette denne afdeling?",
                cancel: "Annuller",
                confirm: "Ja, slet"
            }
        },
        offices: {
            title: "Kontorer",
            breadcrumb: {
                dashboard: "Dashboard",
                allOffices: "Alle Kontorer"
            },
            loading: "Indlæser Kontorer...",
            actions: {
                addOffice: "Tilføj Kontor",
                updateOffice: "Opdater Kontor",
                search: "Søg"
            },
            tableHeaders: {
                officeName: "Kontornavn",
                employeeCount: "Antal Medarbejdere",
                address: "Adresse",
                city: "By",
                zip: "Postnummer"
            },
            pagination: {
                showing: "Viser",
                to: "til",
                of: "af",
                offices: "kontorer",
                previous: "Forrige",
                next: "Næste"
            },
            cell: {
                delete: "Slet",
                confirm: {
                    title: "Bekræft Sletning",
                    message: 'Er du sikker på, at du vil slette kontoret "{{officeName}}"? Handlingen kan ikke fortrydes.',
                    cancel: "Annuller",
                    confirm: "Slet"
                }
            },
            drawer: {
                newTitle: "Nyt Kontor",
                editTitle: "Rediger Kontor",
                closeMenu: "Luk menu",
                location: "Kontorplacering",
                name: "Kontornavn",
                namePlaceholder: "Kontornavn",
                nameValidation: "Skriv venligst mindst 1 bogstav.",
                address: "Kontoradresse",
                addressPlaceholder: "Kontoradresse",
                addressValidation: "Inkluder venligst både vejnavn og nummer.",
                employeeCount: "Antal Medarbejdere",
                employeeCountPlaceholder: "Antal Medarbejdere",
                color: "Kontorfarve (Til Analyse)",
                discard: "Kassér",
                add: "Tilføj Kontor",
                update: "Opdater Kontor"
            }
        },
        settings: {
            modal: {
                general: "Generelt",
                organizationInfo: "Organisationsinfo",
                contactSupport: "Kontakt Support",
                billing: "Fakturering",
                paymentInfo: "Betalingsinformation",
                invoices: "Fakturaer",
                logout: "Log ud"
            },
            general: {
                title: "Brugerindstillinger",
                breadcrumb: {
                    dashboard: "Dashboard",
                    settings: "Indstillinger"
                },
                userProfile: {
                    uploadImage: "Upload billede",
                    changeImage: "Skift billede",
                    removeImage: "Fjern billede",
                    maxSize: "JPG, GIF eller PNG. Maks. størrelse 800KB",
                    userRoles: {
                        owner: "Organisationsejer",
                        admin: "Organisationsadministrator",
                        employee: "Organisationsmedarbejder"
                    }
                },
                socialAccounts: {
                    title: "Sociale konti",
                    socialMedia: "Sociale medier",
                    accountLinked: "Konto tilknyttet",
                    noAccountLinked: "Ingen konto tilknyttet",
                    google: "Google",
                    apple: "Apple",
                    comingSoon: "Kommer snart"
                },
                generalInfo: {
                    firstName: "Fornavn",
                    lastName: "Efternavn",
                    email: "E-mail",
                    phoneNumber: "Telefonnummer",
                    department: "Afdeling",
                    office: "Kontor",
                    noSelection: "Intet valg",
                    selectDepartment: "Vælg afdeling",
                    selectOffice: "Vælg kontor",
                    saveChanges: "Gem ændringer"
                },
                password: {
                    title: "Adgangskodeinformation",
                    currentPassword: "Nuværende adgangskode",
                    newPassword: "Ny adgangskode",
                    confirmPassword: "Bekræft adgangskode",
                    updatePassword: "Opdater adgangskode",
                    requirements: "Krav til adgangskode:",
                    requirementList: [
                        "Mindst 10 tegn (og op til 100 tegn)",
                        "Mindst ét lille bogstav",
                        "Mindst ét specialtegn, f.eks. ! @ # ?"
                    ]
                }
            },
            organization: {
                title: "Organisationsinformation",
                name: "Organisationsnavn",
                registrationNumber: "Registreringsnummer",
                contactEmail: "Kontakt e-mail",
                emailSuffix: "E-mail-suffiks",
                employeeCount: "Antal medarbejdere",
                saveChanges: "Gem ændringer"
            },
            billing: {
                title: "Fakturering",
                breadcrumb: {
                    home: "Hjem",
                    settings: "Indstillinger",
                    billing: "Fakturering"
                },
                intro: {
                    title: "Drivn",
                    description: "Skift dit abonnement til en anden type, såsom månedlig plan, årlig plan eller studieplan. Og se en liste over abonnementsplaner, som Drivn tilbyder.",
                    nextPayment: "Næste betaling på $36 (årligt) sker den 13. august 2024.",
                    changePlan: "Skift plan",
                    cancelSubscription: "Annuller abonnement"
                },
                generalInfo: {
                    title: "Faktureringsoplysninger",
                    firstName: "Fornavn",
                    lastName: "Efternavn",
                    organization: "Organisation",
                    department: "Afdeling",
                    city: "By",
                    role: "Rolle",
                    country: "Land",
                    email: "E-mail",
                    saveChanges: "Gem ændringer"
                },
                cardDetails: {
                    title: "Kortoplysninger",
                    fullName: "(Fulde navn som vist på kortet)*",
                    cardNumber: "Kortnummer *",
                    cvc: "CVC",
                    postalCode: "Post/ZIP-kode (valgfrit)",
                    saveChanges: "Gem ændringer"
                }
            },
            analytics: {
                transport: {
                    activityTypes: {
                        car: "Bil",
                        bus: "Bus",
                        train: "Tog",
                        bike: "Cykel",
                        walk: "Gang",
                        other: "Andet"
                    },
                    mostUtilizedTitle: "Mest Brugte Transporttype",
                    tooltipFormat: "{{value}} km",
                    legendFormat: "{{seriesName}}: {{distance}} km"
                }
            }
        }
    }
};

export default daTranslation;